import { toISODate } from "../../utils/date";

export const financialRecordDefaults = {
    // 1. Opcional - Se gerado a partir de uma "Venda", rastreamos o ID gerador
    idSale: "", 

    // 2. Classificação DRE / Plano de Contas
    type: "INCOME", // "INCOME" (Receita/Receber) ou "EXPENSE" (Despesa/Pagar)
    idCategory: "", // Categoria Financeira (Ex: Mensalidades, Bar, Água, Aluguel)
    categoryName: "",

    // 3. Destinatário/Pagador (A Mágica da Fonte unificada)
    sourceType: "MEMBER", // "MEMBER", "ACQUIRER" (Stone/Cielo), "SUPPLIER" (Fornecedores), "EMPLOYEE" (FolhaPgto)
    idEntity: "", 
    entityName: "", 

    // 4. Se a Origem geradora envolvia alunos/membros ou funcionários
    idMember: "", // Quem comprou 
    memberName: "",
    memberPhone: "",
    memberEmail: "",
    idEmployee: "", // Quem Vendeu / Atendeu na recepção
    employeeName: "", 

    // 5. Fluxo Exato de Valores (DRE e Conciliação)
    grossAmount: 0.00,       // Valor Cheio (Ex: O Aluno Passou R$ 1000 na maquininha)
    feePercentage: 0.0,      // Taxa Retida pela Adquirente/Stone (Ex: 2.50%)
    feeAmount: 0.00,         // Valor Retido (Custo oculto do lojista)
    discount: 0.00,          // Desconto Dado no Ato do Pgto
    fineAndInterest: 0.00,   // Multa Adicionada por Atraso (Se Aluno)
    netAmount: 0.00,         // Valor Líquido = (grossAmount + fineAndInterest) - discount - feeAmount

    // 5. Datas do Fluxo de Caixa Diário e Regime Contábil
    issueDate: toISODate(new Date()),   // Dia que a Conta foi Gerada/Venda Ocorreu
    dueDate: toISODate(new Date()),     // Dia Prometido para o dinheiro CAIR ou SAIR da conta
    competenceDate: toISODate(new Date()), // Regime de Competência (A que mês pertence essa receita/despesa no DRE)
    paymentDate: null,       // Dia Efetivo em que o Boleto foi pago / Maquininha transferiu
    cancellationDate: null,  // Data em que foi cancelado (se CANCELED)

    // 6. Conciliação Bancária e Parcelamento
    idBankAccount: "",       // Na caixa do Itaú, Gaveta da Recepção ou Pix do Inter?
    bankAccountName: "",
    
    paymentMethod: "CASH",   // "CREDIT_CARD", "DEBIT_CARD", "PIX", "CASH", "BOLETO", "TRANSFER"
    currentInstallment: 1,   // Parcela Atual (Ex: 2)
    totalInstallments: 1,    // Total de Parcelas (Ex: 12)
    documentNumber: "",      // NSU do Cartão, Linha do Boleto ou Autenticação DOC/TED

    // 7. Máquina de Estados
    status: "PENDING",       // PENDING, PAID, OVERDUE, CANCELED

    // 8. Opcional - TextoLivre
    cancellationReason: "",  // Se foi cancelado, por qual motivo?
    notes: "" 
};
